import { HStack, Shadow, Text, VStack } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import { Button, View } from 'native-base';
import React from 'react';

import { SplitInput } from '../../../BatchTicketInvestLink/components/CustomerOffers/components/SplitInput';

interface ValidateTokenProps {
  inputProps: {
    value: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    isError: boolean;
    loadingToken: boolean;
  };
  handleValidateToken: (value: string) => void;
}

export const ContainerDesktop: React.FC<ValidateTokenProps> = ({
  inputProps,
  handleValidateToken,
}) => {
  const allInputsFilled = inputProps.value?.toString().length === 6;

  return (
    <View minW="container" maxWidth={900}>
      <Shadow
        level={1}
        mt="inline.xl"
        px="inline.xxxs"
        py="inline.xxxs"
        borderRadius={BoxRadius.sm}>
        <VStack space="inline.xxs" bg="neutral.white">
          <VStack alignItems="center" space="inline.xs" flex={1}>
            <Text fontSize="xl" variant="semibold" textAlign="center">
              Insira seu token
            </Text>
            <Text>Informe abaixo o token que enviamos para o seu WhatsApp.</Text>

            <HStack maxWidth={368}>
              <SplitInput {...inputProps} />
            </HStack>

            <Text variant="regular" pb="inline.md">
              Caso não tenha recebido um token entre em contato com seu(sua) assessor(a).
            </Text>
          </VStack>

          <Button
            variant="primary"
            isLoading={inputProps.loadingToken}
            spinnerPlacement="end"
            isLoadingText="Validando..."
            mb="inline.nano"
            isDisabled={inputProps.isError || !allInputsFilled || inputProps.loadingToken}
            onPress={() => handleValidateToken(inputProps.value)}
            p="inline.nano"
            minH="inline.sm"
            bg="brand.tertiary.principal"
            borderRadius="100px"
            alignSelf="center"
            w={368}
            _text={{
              textTransform: 'uppercase',
              variant: 'semibold',
              fontSize: 'md',
            }}>
            Verificar token
          </Button>
        </VStack>
      </Shadow>
    </View>
  );
};
